module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container text-center mt-3"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(this.username) ? _c('div', {
    key: "reported",
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container col-sm-6 pt-5"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "mb-5"
  }, [(this.started) ? _c('h1', [_vm._v("Witaj, " + _vm._s(_vm.username))]) : _c('h1', [_vm._v("Żegnaj, " + _vm._s(_vm.username))])]), _vm._v(" "), (this.started) ? _c('h2', [_vm._v("Rozpoczęcie pracy:")]) : _c('h2', [_vm._v("Zakończenie pracy:")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.displayTime()))])])])]) : _c('div', {
    key: "ready"
  }, [_c('HiddenInput', {
    on: {
      "inputConfirmed": _vm.report
    }
  }), _vm._v(" "), _c('div', [_c('h2', [_vm._v("Przyłóż swoją kartę do czytnika")])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-18a65bff!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/ia/RfidLogin.vue
// module id = 1087
// module chunks = 0